import { type AlertColor, type SnackbarOrigin } from '@mui/material';
import { createContext } from 'react';

export interface ShowNotificationOptions {
  message: string;
  severity?: AlertColor;
  duration?: number;
  playSound?: boolean;
  position?: SnackbarOrigin;
}

export interface NotificationContextType {
  showNotification: (options: ShowNotificationOptions) => void;
}

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined);
